import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import './App.css'
import NavBar from './Components/NavBar.jsx'
import MainArea from './Components/MainArea'
import StackArea from './Components/StackArea'
import ContactArea from './Components/ContactArea'

function App() {
  return (
    <Router>
        <NavBar/>
        <Routes>
          <Route path='/' element={
            <>
              <MainArea/>
              <StackArea/>
            </>
          }/>
          <Route path='/stack' element={<StackArea/>}/>
          <Route path='/contact' element={<ContactArea/>}/>
        </Routes>
    </Router>
  )
}

export default App
